module.exports = __webpack_public_path__ + "img/2026-3.fd4ef950.jpg";